<template>
  <div class="py-5">
    <h1 v-if="ocrStore.ocrType == 1" class="text-xl font-semibold pb-7">
      {{ $t('scanBackSideOfEid') }}
    </h1>
    <h1 v-else class="text-xl font-semibold pb-7">
      {{ $t('scanPassport') }}
    </h1>
    <img :src="eidBack" v-if="ocrStore.ocrType == 1" class="w-80 h-auto" />
    <div
      v-else
      class="w-80 flex flex-col gap-y-3 aspect-video bg-gradient-to-tr from-linear-s/60 to-linear-e/30 border border-primary rounded-lg"
    >
      <img :src="ocrPassportPerson" class="ms-4 mt-3 w-16 md:w-20 h-auto" />
      <div class="w-full flex-1 px-4 py-2 rounded-b-lg bg-white">
        <p class="tracking-wide flex flex-wrap gap-0.5 text-brand-black-secondary">
          P&nbsp;<faChevronLeft
            :key="i"
            class="w-[0.3rem] md:w-2 fill-black"
            v-for="i in Array(Math.floor(24 * 2.33))
              .fill()
              .map((_, i) => i)"
          />
        </p>
      </div>
    </div>
    <div class="flex flex-col text-center items-center pt-4 text-sm">
      <div class="flex gap-x-3">
        <div class="flex gap-x-1.5">
          <span class="text-brand-black-autofill">{{ $t('imageSize') }}</span>
          <span class="text-primary">{{ $t('imageSizeValue') }}</span>
        </div>
        <div class="flex gap-x-1.5">
          <span class="text-brand-black-autofill">{{ $t('imageFormat') }}</span>
          <span class="text-primary">{{ $t('imageFormatValue') }}</span>
        </div>
      </div>

      <span class="text-brand-black-autofill">{{ $t('PleaseEnsure') }}</span>
    </div>
    <div class="pt-10 w-full flex flex-col"></div>
    <div class="max-w-[32rem] w-full flex flex-col items-center gap-y-5">
      <button
        class="px-1.5 rounded-md bg-gradient-to-tr from-linear-s to-linear-e flex items-center hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
        @click="openFileDialog"
      >
        <div class="flex justify-center items-center h-full p-2 rounded-s">
          <ocrUploadIcon class="w-4 fill-white" />
        </div>
        <span
          v-if="ocrStore.ocrType == 1"
          class="px-1.5 ltr:font-sans tracking-wide text-white text-sm pb-[1px]"
        >
          {{ $t('uploadEidPhoto') }}
        </span>
        <span v-else class="px-1.5 ltr:font-sans tracking-wide text-white text-sm pb-[1px]">
          {{ $t('uploadPassportPhoto') }}
        </span>
      </button>
      <div class="w-full flex justify-center items-center gap-x-3">
        <div class="w-full border-b border-primary"></div>
        <span class="text-xs">{{ $t('OR') }}</span>
        <div class="w-full border-b border-primary"></div>
      </div>
      <button
        class="px-1.5 rounded-md border border-primary flex items-center hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed"
        @click="$emit('onTransition', 'camera')"
      >
        <div class="flex justify-center items-center h-full p-2 rounded-s">
          <ocrCameraIcon class="w-3 fill-primary" />
        </div>
        <span
          v-if="ocrStore.ocrType == 1"
          class="px-2 ltr:font-sans tracking-wide text-primary text-sm pb-[1px]"
        >
          {{ $t('scanEidByCamera') }}
        </span>
        <span v-else class="px-2 ltr:font-sans tracking-wide text-primary text-sm pb-[1px]">
          {{ $t('scanPassportByCamera') }}
        </span>
      </button>
    </div>
  </div>
</template>

<script setup>
import faChevronLeft from '@/assets/icons/faChevronLeft.svg?component'
import ocrCameraIcon from '@/assets/icons/ocrCamera.svg?component'
import ocrUploadIcon from '@/assets/icons/ocrUpload.svg?component'
import ocrPassportPerson from '@/assets/pngs/ocrPassportPerson.png'
import eidBack from '@/assets/pngs/pic_card_eid.png'
import { useOcrStore } from '@/stores/ocr'
import { useFileDialog } from '@vueuse/core'
import { nextTick } from 'vue'

const emit = defineEmits(['onTransition'])

const ocrStore = useOcrStore()

const {
  files,
  open: openFileDialog,
  reset,
  onChange
} = useFileDialog({
  accept: 'image/*', // Set to accept only image files,
  multiple: false
})

async function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.readAsDataURL(blob)
  })
}

onChange(async (fileList) => {
  await nextTick()
  const file = fileList[0]

  var img = new Image()
  img.src = URL.createObjectURL(file)
  img.onload = function () {
    var canvas = document.createElement('canvas')
    canvas.width = img.width
    canvas.height = img.height
    var ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0)
    canvas.toBlob(
      async function (blob) {
        ocrStore.uploadedFile = await blobToBase64(blob)
        ocrStore.operationType = 'scanning'
        emit('onTransition', 'confirm')
      },
      'image/jpeg',
      0.7
    )
  }
})
</script>

<style lang="scss" scoped></style>
